import React, { useEffect, useContext, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import clsx from "clsx";
import { AuthContext } from "../auth";
import firebase from "../firebase";
import LifeDocLogoWhite from "../Assets/LifeDlogoWhite.png";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";

const useStyles = makeStyles((theme) => ({
  logo: {
    //height: 100,
    width: 250,
    cursor: "pointer",
  },
  toolbar: {
    padding: 2,
  },
  forumExtension: {
    alignItems: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  forumHeader: {
    color: theme.palette.common.white,
  },
  button: {
    marginRight: theme.spacing(2),
    fontWeight: "bold",
    color: theme.palette.common.white,
    transition: theme.transitions.create(["color", "background"], {
      duration: 600,
    }),
    "&:hover": {
      color: theme.palette.primary.main,
      background: theme.palette.common.white,
    },
  },
  menuItem: {
    "&:last-child": {
      fontWeight: "bold",
      color: theme.palette.error.main,
    },
  },
}));

export const MenuBar = React.createContext();
export const ScrollToTop = React.createContext();

export const MenuBarProvider = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname } = useLocation();
  const rootElement = useRef(null);
  const { currentUser } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [MenuBarState, setMenuBarState] = React.useState({
    logo: LifeDocLogoWhite,
    headerColor: "primary",
    buttonColor: "default",
    theme: "dark",
  });
  const [activePath, setActivePath] = React.useState("");
  const open = Boolean(anchorEl);
  const id = open ? "simple-menu" : undefined;

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    try {
      await firebase.auth().signOut();
      handleClose();
      history.replace("/");
    } catch (error) {
      //console.log(error);
    }
  };

  const handleScroll = () => {
    rootElement.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  ///*
  useEffect(() => {
    setActivePath(pathname.slice(0, 6));
  }, [pathname]);
  //*/
  //*/

  let menuContent = null;

  menuContent =
    pathname === "/login" ||
    pathname === "/forgot_password" ||
    pathname === "/doctor_register" ? null : (
      <header ref={rootElement}>
        <AppBar
          position="static"
          color={MenuBarState.headerColor}
          elevation={0}
        >
          <Toolbar
            className={clsx(
              classes.toolbar,
              activePath === "/forum" ? classes.forumExtension : null
            )}
            variant="dense"
          >
            <Grid container justify="center" alignItems="center">
              <Grid item>
                <img
                  src={MenuBarState.logo}
                  alt="lifedoctor"
                  className={classes.logo}
                  onClick={() => history.push("/")}
                />
              </Grid>
              <Grid item xs={2} lg={6} />
              <Grid item>
                <Button
                  id="/Forum"
                  color={MenuBarState.buttonColor}
                  className={classes.button}
                  onClick={() => history.push("/forum/main")}
                  size="large"
                >
                  Forum
                </Button>

                <Button
                  id="/About"
                  color={MenuBarState.buttonColor}
                  className={classes.button}
                  onClick={() => history.push("/about")}
                  size="large"
                >
                  About
                </Button>
                <span>
                  <Button
                    aria-describedby={id}
                    color={MenuBarState.buttonColor}
                    variant="outlined"
                    className={classes.button}
                    endIcon={currentUser ? <ArrowDropDownRoundedIcon /> : null}
                    onClick={(e) => {
                      currentUser ? handleClick(e) : history.push("/login");
                    }}
                    size="large"
                  >
                    {currentUser
                      ? `Hello, ${currentUser.displayName}`
                      : "Login/Signup"}
                  </Button>
                  <Menu
                    id={id}
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        history.push("/profile");
                      }}
                      className={classes.menuItem}
                    >
                      Profile
                    </MenuItem>
                    <Divider />
                    <MenuItem
                      onClick={handleSignOut}
                      className={classes.menuItem}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </span>
              </Grid>
              <Collapse
                in={activePath === "/forum" ? true : false}
                mountOnEnter
                unmountOnExit
                timeout={500}
              >
                <Grid item lg={12}>
                  <Typography component="div" className={classes.forumHeader}>
                    <Box
                      display="flex"
                      textAlign="center"
                      fontSize={40}
                      fontWeight="bold"
                      justifyContent="center"
                      alignItems="center"
                      m={2}
                    >
                      FORUM
                    </Box>
                    <Box
                      display="flex"
                      textAlign="center"
                      whiteSpace="normal"
                      fontWeight={400}
                      justifyContent="center"
                      alignItems="center"
                      width={550}
                    >
                      Ask and discusss anything related to your personal health
                      queries, condition, recommendations, and even directories
                    </Box>
                  </Typography>
                </Grid>
              </Collapse>
            </Grid>
          </Toolbar>
        </AppBar>
      </header>
    );

  const MenuState = {
    setMenuBarState: setMenuBarState,
  };

  const ScrollState = {
    handleScroll: handleScroll,
  };
  return (
    <MenuBar.Provider value={MenuState}>
      <ScrollToTop.Provider value={ScrollState}>
        {menuContent}
        {children}
      </ScrollToTop.Provider>
    </MenuBar.Provider>
  );
};

/* Old Menubar
const Menubar = ({ logo, headerColor, buttonColor, theme, ...rest }) => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname } = useLocation();


  const { currentUser } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    try {
      await firebase.auth().signOut();
      history.replace("/");
    } catch (error) {
      //console.log(error);
    }
  };

  let menuContent = null;

  menuContent =
    pathname === ("/login" || "/doctor-register") ? null : (
      <header>
        <AppBar position="static" color={headerColor} elevation={0}>
          <Toolbar
            className={clsx(
              classes.toolbar,
              pathname === "/forum" ? classes.forumExtension : null
            )}
            variant="dense"
          >
            <Grid container justify="center" alignItems="center">
              <Grid item>
                <img
                  src={logo}
                  alt="lifedoctor"
                  className={classes.logo}
                  onClick={() => history.push("/")}
                />
              </Grid>
              <Grid item xs={2} lg={6} />
              <Grid item>
                <Button
                  id="/Forum"
                  color={buttonColor}
                  className={classes.button}
                  onClick={() => history.push("/forum")}
                  size="large"
                >
                  Forum
                </Button>

                <Button
                  id="/About"
                  color={buttonColor}
                  className={classes.button}
                  onClick={() => history.push("/about")}
                  size="large"
                >
                  About
                </Button>

         
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                color={props.buttonColor}
                variant="outlined"
                className={props.theme === "dark" ? classes.button : ""}
                endIcon={currentUser ? <ArrowDropDownRoundedIcon /> : null}
                onClick={(e) => {
                  currentUser ? handleClick(e) : history.push("/Login");
                }}
                size="large"
              >
                {currentUser
                  ? `Hello, ${currentUser.displayName}`
                  : "Login/Signup"}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <MenuItem onClick={() => history.push("/Profile")}>
                  Profile
                </MenuItem>
                <MenuItem onClick={handleSignOut}>Logout</MenuItem>
              </Menu>

              </Grid>
              <Collapse in={pathname === "/forum" ? true : false}>
                <Grid item lg={12}>
                  <Typography component="div" className={classes.forumHeader}>
                    <Box
                      display="flex"
                      textAlign="center"
                      fontSize={40}
                      fontWeight="bold"
                      justifyContent="center"
                      alignItems="center"
                      m={2}
                    >
                      FORUM
                    </Box>
                    <Box
                      display="flex"
                      textAlign="center"
                      whiteSpace="normal"
                      fontWeight={400}
                      justifyContent="center"
                      alignItems="center"
                      width={550}
                    >
                      Ask and discusss anything related to your personal health
                      queries, condition, recommendations, and even directories
                    </Box>
                  </Typography>
                </Grid>
              </Collapse>
            </Grid>
          </Toolbar>
        </AppBar>
      </header>
    );

  return menuContent;
};

export default Menubar;
*/
